var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("p", { staticClass: "text-secondary block-headline w-100" }, [
    _c("i", { staticClass: "fad", class: _vm.headlineIcon }),
    _vm._v(_vm._s(_vm.text) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }